import styled from "styled-components"

export const ContainerHeader = styled.div`
  z-index: 1000;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  background: white;
  #menu-principal,
  #menu-principal > ul,
  #menu-principal .sub-menu > div,
  #menu-principal .sub-menu,
  #menu-principal button svg,
  #menu-principal > ul > li > button {
    -webkit-transition-duration: 0.5s;
    -moz-transition-duration: 0.5s;
    -ms-transition-duration: 0.5s;
    -o-transition-duration: 0.5s;
    transition-duration: 0.5s;
  }
  #menu-principal {
    width: auto;
  }
  .logo > img {
    margin-top: -10px;
  }
  #menu-principal .sub-menu > div {
    border-top: 4px solid #1465ff;
  }
  #menu-principal .sub-menu > div::before {
    content: " ";
    top: -9px;
    left: 60px;
    position: absolute;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #1465ff;
  }
  #menu-principal li {
    position: relative;
    display: inline-block;
  }
  #menu-principal .sub-menu {
    position: absolute;
    top: 100%;
    left: 0;
    display: inline-block;
    width: 100%;
  }
  #menu-principal .sub-menu > div {
    visibility: hidden;
    opacity: 0;
    transform: scale(0.9);
  }
  #menu-principal > ul > li > button {
    top: 0px;
    overflow: hidden;
    background: white;
  }
  #menu-principal button svg {
    rotate: 0deg;
  }
  #menu-principal button.active span {
    color: #1465ff;
  }
  #menu-principal button.active svg {
    color: #1465ff;
    rotate: 180deg;
  }
  #menu-principal > ul > li > button.active {
    overflow: visible;
  }
  #menu-principal > ul > li > button.active > .sub-menu {
    top: 100%;
  }
  #menu-principal > ul > li > button.active > .sub-menu > div {
    visibility: visible;
    opacity: 1;
    transform: scale(1);
  }
  .links {
    justify-content: center;
    display: flex;
    cursor: pointer;
    color: #1465ff;
    border: 2px solid #1465ff;
    padding: 15px 20px;
    transition-duration: 0.25s;
    background-color: white;
    border-radius: 28px;
    opacity: 1;
    text-align: center;
    font-size: 1rem;
    font-weight: 500;
    width: 100%;

    &:hover {
      background-color: #1465ff;
      color: white;
      transform: translateY(-3px);
      box-shadow: 0 1rem 2.5rem rgba(22, 28, 45, 0.1),
        0 0.5rem 1rem -0.75rem rgba(22, 28, 45, 0.1);
    }
  }
  @media (min-width: 770px) and (max-width: 1024px) {
    .logo > img {
      margin-left: -10px;
    }
    #menu-principal > ul > li > button {
      padding: 1.25rem 3px;
    }
    #menu-principal > ul > li > button > svg {
      margin-left: 0px;
    }
    #menu-principal > ul > li > a {
      padding: 10px;
    }
    #menu-principal > ul > li > a,
    #menu-principal > ul > li > button > span {
      font-size: 14px;
    }
  }
  @media (max-width: 769px) {
    .special-links > a {
      padding: 15px;
      width: 100%;
      display: inline-block;
    }
    .special-links > a {
      padding: 15px;
      width: 100%;
      display: inline-block;
      padding-left: 20px;
      text-align: left;
    }
    #menu-principal {
      background: white;
    }
    #menu-principal > ul {
      top: -10%;
    }
    #menu-principal.active > ul {
      top: 100%;
    }
    #menu-principal > ul {
      background: white;
      visibility: hidden;
      overflow: hidden;
      opacity: 0;
    }
    #menu-principal.active > ul {
      overflow: inherit;
      visibility: visible;
      opacity: 1;
    }
    #menu-principal.active .sub-menu {
      top: 100%;
    }
    #menu-principal > ul > li > button > .sub-menu > div {
      transform: scale(1);
    }
    #menu-principal > ul > li > button {
      overflow: hidden;
      height: 53px;
      animation-direction: reverse;
    }
    #menu-principal > ul > li > button.active {
      animation: desplazarMenu 0.5s ease;
      height: auto;
    }
    #menu-principal > ul > li > button > .sub-menu {
      margin-left: -130px;
    }
    #menu-principal > ul > li > button.active > .sub-menu {
      top: 0px;
      margin-top: 40px;
    }
    #menu-principal .sub-menu,
    #menu-principal .sub-menu > div {
      position: relative;
      width: 100%;
      max-width: 100%;
      display: inline-block;
      top: 0px;
    }
    #menu-principal .sub-menu > div {
      padding: 0;
      margin: 0;
    }
    .btnMenu {
      position: relative;
      border-top: 1px solid #ececec;
    }
    .btnMenu svg {
      position: absolute;
      right: 0px;
      top: 10px;
    }
    #menu-principal > ul {
      position: absolute;
      left: 0;
      top: 100%;
      width: 100%;
      background: white;
      border-bottom: 5px solid #1465ff;
      text-align: center;
    }
    #menu-principal > ul > li {
      width: 100%;
    }
    #menu-principal > ul > li > button {
      width: 100%;
      padding-right: 0px;
      padding-top: 14px;
      padding-bottom: 14px;
    }
    #menu-principal > ul > li.flex {
      width: 50%;
      text-align: center;
      border-top: 1px solid #ececec;
      padding-top: 14px;
      padding-bottom: 14px;
    }

    #menu-principal > ul > li {
      max-width: 640px;
      padding-right: 2rem;
      padding-left: 2rem;
    }
    #menu-principal > ul > li:nth-last-child(2) {
      line-height: 51px;
      border-right: 1px solid #ececec;
    }
    #menu-principal > ul > li > a {
      margin-left: 0px;
    }
  }
  @media (max-width: 590px) {
    .sub-menu a {
      text-align: center;
    }
    .sub-menu img {
      height: 70px;
      display: inline-block;
    }
    #menu-principal > ul > li > a,
    #menu-principal > ul > li > button,
    .sub-menu > div > div > div {
      padding-left: 0px;
      padding-right: 0px;
    }
    .sub-menu .pt-6.pb-2.text-base.font-medium.text-gray-900 {
      padding-top: 10px;
    }
    .sub-menu .ml-4 {
      margin-right: 1rem;
    }
    #menu-principal > ul > li {
      max-width: auto;
      padding-right: 1.2rem;
      padding-left: 1.2rem;
    }
    #menu-principal > ul > li.flex {
      width: 100%;
      text-align: center;
      border-top: 1px solid #ececec;
      padding-top: 0px;
      padding-bottom: 0px;
    }
    #menu-principal > ul > li.flex:last-of-type {
      padding-top: 14px;
      padding-bottom: 14px;
    }
    #menu-principal > ul > li:nth-child(3) > button.active {
      top: -131px;
    }
    .sub-menu > div > div > div > div.grid {
      max-height: 500px;
      overflow: hidden;
      overflow-y: scroll;
    }
  }

  @keyframes desplazarMenu {
    0% {
      height: 0%;
    }
    100% {
      height: calc(100%+5px);
    }
  }
`
